import economic from './economic'
import amazon from './amazon'
import shopify from './shopify'

/**
 * @description Call different custom auth functions based on the app slug
 * @param {Object} params
 * @param {string} params.appSlug
 * @param {Object} params.params
 * @param {string} params.apiKey
 * @returns {Promise<any>}
 */
export default async ({ appSlug, params, apiKey }) => {
  switch (appSlug) {
    case 'economic':
      return await economic({ appSlug, params })
    case 'amazon':
      return await amazon({ appSlug, params, apiKey })
    case 'shopify':
      return await shopify({ appSlug, params, apiKey })
    default:
      break
  }
}
